/**
 * Plush hero slideshow.
 *
 * A lightweight slideshow over a native scroll-snap track: swipe works for free,
 * the dots reflect and control the current slide, and it auto-rotates with a
 * SEAMLESS infinite loop. The slide set is cloned once and appended; autoplay only
 * moves forward, and when it scrolls into the clones it instantly snaps back one
 * set width — so it never does the ugly "rewind to the first slide" scroll.
 * Pauses on hover/touch so it never fights the shopper.
 */
(function () {
  'use strict';

  function initHero(hero) {
    if (hero.dataset.heroReady === '1') return;
    hero.dataset.heroReady = '1';

    var track = hero.querySelector('[data-hero-track]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.nodeType === 1;
    });
    var count = originals.length;
    if (count < 2) return;

    // Clone the slides once for the seamless loop; keep clones out of the a11y tree
    // and the tab order.
    originals.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.clone = '1';
      Array.prototype.forEach.call(clone.querySelectorAll('a, button, input, [tabindex]'), function (el) {
        el.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
    });

    var slides = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.nodeType === 1;
    });
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));

    // Distance between slide starts (slide width + gap).
    function step() {
      return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
    }
    function index() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }
    function goTo(i, instant) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function refreshDots() {
      var cur = ((index() % count) + count) % count;
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === cur);
      });
    }
    // If we've scrolled into the cloned set, jump back one set (instant, invisible).
    function normalize() {
      var i = index();
      if (i >= count) {
        track.scrollTo({ left: slides[i - count].offsetLeft, behavior: 'auto' });
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
      });
    });

    var raf, settleTimer;
    track.addEventListener(
      'scroll',
      function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(refreshDots);
        clearTimeout(settleTimer);
        settleTimer = setTimeout(normalize, 130);
      },
      { passive: true }
    );

    // Autoplay (optional), paused on interaction.
    var interval = parseInt(track.getAttribute('data-hero-autoplay'), 10);
    if (interval > 0) {
      var timer = null;
      var start = function () {
        stop();
        timer = setInterval(function () {
          goTo(index() + 1);
        }, interval * 1000);
      };
      var stop = function () {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      hero.addEventListener('pointerenter', stop);
      hero.addEventListener('pointerdown', stop);
      hero.addEventListener('pointerleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
      start();
    }

    refreshDots();
  }

  function boot() {
    document.querySelectorAll('.plush-hero').forEach(initHero);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', boot);
})();
